"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiTacAuthorizationStatusRetrieveWrapper = exports.apiMfaSendOtpWrapper = exports.apiAccesHardWareSubmitWrapper = exports.apiAccessElevationvValidateWrapper = exports.apiAccessElevationRequestWrapper = void 0;
const effects_1 = require("redux-saga/effects");
const tfa_1 = require("@/data-manager/ms-cust-sec/tfa");
const constants_1 = require("@/common/utils/constants");
const constants_2 = require("../constants");
function* apiAccessElevationRequestWrapper(request, headers) {
    try {
        // const params = {
        // } as IAccessElevation_ReqRequest;
        const response = yield (0, effects_1.call)(apiAccessElevationRequest, request, headers);
        if (response.status === 'SUCCESS' && response.data.authorizationId && response.data.transactionId) {
            return {
                isError: false,
                data: response
            };
        }
        else if (response.status === 'FAILED' && response.errorCode === 'CAUTH-20023') {
            return {
                isError: true,
                errorCode: response.errorCode,
                systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.TOKEN_VALIDATION_ERROR
            };
        }
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    catch (error) {
        console.error('apiAccessElevationRequestWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    // return {
    //     isError: true,
    //     systemMessages: SYSTEM_MESSAGES_COMMON.UNKNOWN_ERROR,
    // } as IAccessElevation_ReqResponseWrapper;
}
exports.apiAccessElevationRequestWrapper = apiAccessElevationRequestWrapper;
function* apiAccessElevationvValidateWrapper(request, headers) {
    try {
        // const params = {
        // } as IAccessElevation_ValidateRequest;
        const response = yield (0, effects_1.call)(apiAccessElevationValidate, request, headers);
        if (response.status &&
            (response.status === constants_2.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_SUCCESS || response.status === constants_2.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_FAILED)) {
            return {
                isError: false,
                data: response
            };
        }
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    catch (error) {
        console.error('apiAccessElevationvValidateWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    // return {
    //     // isError: true,
    //     // systemMessages: SYSTEM_MESSAGES_COMMON.UNKNOWN_ERROR,
    // } as IAccessElevation_ValidateResponseWrapper;
}
exports.apiAccessElevationvValidateWrapper = apiAccessElevationvValidateWrapper;
function* apiAccesHardWareSubmitWrapper(request, headers) {
    try {
        const response = yield (0, effects_1.call)(apiAccesHardWareSubmit, request, headers);
        if (response.body &&
            (response.body === constants_2.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_SUCCESS || response.body === constants_2.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_FAILED)) {
            return {
                isError: false,
                data: response
            };
        }
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    catch (error) {
        console.error('apiAccesHardWareSubmitWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
}
exports.apiAccesHardWareSubmitWrapper = apiAccesHardWareSubmitWrapper;
function* apiMfaSendOtpWrapper(request, headers) {
    try {
        // const params = {
        // } as IMfa_SendOtpRequest;
        const response = yield (0, effects_1.call)(apiMfaSendOtp, request, headers);
        return {
            isError: false,
            data: response
        };
    }
    catch (error) {
        console.error('apiMfaSendOtpWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    // return {
    //     // isError: true,
    //     // systemMessages: SYSTEM_MESSAGES_COMMON.UNKNOWN_ERROR,
    // } as IMfa_SendOtpResponseWrapper;
}
exports.apiMfaSendOtpWrapper = apiMfaSendOtpWrapper;
function* apiTacAuthorizationStatusRetrieveWrapper(request, headers) {
    try {
        const params = {
            authorizationId: request.authorizationId,
            transactionId: request.transactionId,
            txRef: request.txRef
        };
        console.log('apiTacAuthorizationStatusRetrieveWrapper_request', request);
        const response = yield (0, effects_1.call)(apiTacAuthorizationStatusRetrieve, params, headers);
        if (response.status === 'SUCCESS' || response.status === 'FAILED' || response.status === 'PENDING') {
            return {
                isError: false,
                data: response
            };
        }
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.UNKNOWN_ERROR
        };
    }
    catch (error) {
        console.error('apiTacAuthorizationStatusRetrieveWrapper, error: ', error);
        return {
            isError: true,
            systemMessages: constants_1.SYSTEM_MESSAGES_COMMON.API_ERROR
        };
    }
    // return {
    //     isError: true,
    //     systemMessages: SYSTEM_MESSAGES_COMMON.UNKNOWN_ERROR,
    // } as ITac_AuthorizationStatus_RetrieveResponseWrapper;
}
exports.apiTacAuthorizationStatusRetrieveWrapper = apiTacAuthorizationStatusRetrieveWrapper;
/// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const apiAccessElevationRequest = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    console.log('apiAccessElevationRequest, request:', request);
    const result = yield (0, tfa_1.accessElevationRequest)(request, headers);
    console.log('apiAccessElevationRequest, result:');
    console.log(result);
    return result;
});
const apiAccessElevationValidate = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield (0, tfa_1.accessElevationValidate)(request, headers);
    console.log('apiAccessElevationValidate, result:');
    console.log(result);
    return result;
});
const apiAccesHardWareSubmit = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield (0, tfa_1.accesHardWareSubmit)(request, headers);
    console.log('apiAccesHardWareSubmit, result:');
    console.log(result);
    return result;
});
const apiMfaSendOtp = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield (0, tfa_1.mfaSendOtp)(request, headers);
    console.log('apiMfaSendOtp, result:');
    console.log(result);
    return result;
});
const apiTacAuthorizationStatusRetrieve = (request, headers) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield (0, tfa_1.tacAuthorizationStatusRetrieve)(request, headers);
    console.log('apiTacAuthorizationStatusRetrieve, result:');
    console.log(result);
    return result;
});
